import withNavigate from "../../../routes/withNavigate";
import QualificationMasterContainer from "./QualificationMasterContainer.jsx";
import QualificationMasterStore from "./QualificationMasterStore";

export default QualificationMasterStore(withNavigate(QualificationMasterContainer));